export default __webpack_public_path__ + "static/media/goalbase_navicon-light.b5df0850.svg";